export default {
  customerServices: 'Client Services',
  integrations: 'Integrations',
  price: 'Price',
  functionality: 'Functionality',
  ceasedTrading: 'Ceased Trading',
  serviceNoLongerRequired: 'Service No Longer Required',
  other: 'Other'
}
